module.exports = __webpack_public_path__ + "img/Add-icon.c8dbb1da.svg";